import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';

export interface TaskFilterOption {
   value: string;
   label: string;
}

/**
 * Standard (non-legacy) mat-select, kept in its own standalone component so it can import
 * `MatSelectModule` from `@angular/material/select` directly instead of the app-wide
 * `MatLegacySelectModule` alias every other `mat-select` in this codebase uses. The legacy
 * select's overlay panel always renders ~32px wider than its trigger and re-centers itself
 * over whichever option is selected, which is what made it spill onto neighboring content;
 * the standard select has neither behavior, so it needs no width/position workarounds.
 */
@Component({
   selector: 'app-task-filter-select',
   standalone: true,
   imports: [CommonModule, MatSelectModule],
   templateUrl: './task-filter-select.component.html',
   styleUrls: ['./task-filter-select.component.css']
})
export class TaskFilterSelectComponent {
   @Input() value: string;
   @Input() options: TaskFilterOption[] = [];
   /** Rendered as the closed trigger's text; passed in rather than left to mat-select's own
    *  default (which mirrors the selected mat-option's text) so it keeps working the same way
    *  the previous legacy-select trigger did when translations finish loading after the first
    *  render. */
   @Input() triggerLabel = '';
   @Output() valueChange = new EventEmitter<string>();
}
